import LineCommentsIcon from 'LuxKit/Icons/line/LineCommentsIcon'
import * as React from 'react'
import { useIntl } from 'react-intl'
import NavBarButton from '../NavBarButton/NavBarButton'
import { useAppSelector } from 'hooks/reduxHooks'
import { isSupportAssistantEnabled } from 'selectors/featuresSelectors'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import useOrders from 'hooks/Order/useOrders'
import Group from 'components/utils/Group'
import Caption from 'LuxKit/Typography/Caption'

interface Props {
  className?: string
}

function NavBarChatButton(props: Props) {
  const intl = useIntl()
  const chatEnabled = useAppSelector(isSupportAssistantEnabled)
  const [upcomingOrders] = useOrders('upcoming')
  const hasUpcomingOrder = !!upcomingOrders.length

  const helpMessage = intl.formatMessage(
    {
      id: 'YqF27GQ_nXKeUGAxeuMz',
      defaultMessage: 'Need help with your booking?',
    },
  )

  const chatButtonText = intl.formatMessage(
    {
      id: 'q-oELIFfeF29f6VhgL5_',
      defaultMessage: 'Chat<desktop> Now</desktop>',
    },
    {
      desktop: (chunks: React.ReactNode) => (
        <CSSBreakpoint key="desktop-text" as="span" min="desktop">
          {chunks}
        </CSSBreakpoint>
      ),
    },
  )

  if (!chatEnabled) {
    return null
  }

  return <Group direction="horizontal" gap={4} verticalAlign="center" className={props.className}>
    {hasUpcomingOrder && <Caption variant="medium" wrap="no-wrap">
      {helpMessage}
    </Caption>}
    <NavBarButton
      icon={<LineCommentsIcon />}
      to="/support"
      size="small"
    >
      {chatButtonText}
    </NavBarButton>
  </Group>
}

export default React.memo(NavBarChatButton)
